export const Features = Object.freeze({
    DASHBOARD: 'dashboardSection',
    TOOLS_AND_AGENTS: 'toolsAndAgentsSection',
    CHATS: 'chatsSection',
    EXTRACTION: 'extractionSection',
    TEMPLATE: 'templateSection',
    LAYOUT: 'layoutSection',
    SUPPORT: 'supportSection',
    BILLING: 'billingSection',
    NOTIFICATION: 'notificationSection',
    SETTINGS: 'settingsSection',
    OTHERS: 'others',
    ADD_NEW_REPOSITORY: 'addNewRepo'
});

export const DashboardFeatures = Object.freeze({
    ADD_NEW_DASHBOARD: 'addNewDashboard',
    IMPORT_DASHBOARD: 'importDashboard',
    EXPORT_DASHBOARD: 'exportDashboard',
    EDIT_DASHBOARD: 'editDashboard',
    DELETE_DASHBOARD: 'deleteDashboard',
});
export const AddNewRepoFeatures = Object.freeze({
  ADD_FILE: 'addFileRepo',
  ADD_DATABASE: 'addDatabaseRepo',
  ADD_INTERNET: 'addInternetRepo',
  ADD_CLOUD: 'addCloudRepo',
  ADD_TABULAR: 'addTabular'
});
export const ChatsFeatures = Object.freeze({
    ADD_NEW_REPOSITORY: 'addNewRepository',
    CHAT_ON_REPOSITORY: 'chatOnRepository',
    ADD_FILE: 'addFile',
    VIEW_FILE: 'viewFile',
    CHAT_ON_FILE: 'chatOnFile',
    DELETE_FILE: 'deleteFile',
    EXTRACT_TABLES: 'extractTables',
    SHARE_REPOSITORY: 'shareRepository',
    SET_DEFAULT_TEMPLATE: 'setDefaultTemplate',
    EXTRACT_DATA_TO_DB: 'extractDataToDB',
    RE_RUN_EXTRACTION: 'reRunExtraction',
    UPDATE_REPOSITORY: 'updateRepository',
    PRODUCT_MAPPING: 'productMapping',
    VIEW_REPOSITORY_STATUS: 'viewRepositoryStatus',
    VIEW_DATABASE_STATUS: 'viewDatabaseStatus',
    DELETE_REPOSITORY: 'deleteRepository',
    UPDATE_SCHEMA: 'updateSchema',
    DOWNLOAD_SCHEMA: 'downloadSchema',
    UPLOAD_ANNOTATED_SCHEMA: 'uploadAnnotatedSchema',
    ADD_URL: 'addUrl',
    CRAWL_HISTORY: 'crawlHistory',
    DOWNLOAD_DIAGNOSTIC_DATA: 'downloadDiagnosticData',
    ENABLE_ORGANIZATION_ACCESS: 'EnableOrganizationAccess',
    ENABLE_TELEGRAM_BOT: 'enableTelegramBot',
    ENABLE_WHATSAPP: 'enableWhatsapp',
    ENABLE_EMAIL_INTERFACE: 'enableEmailInterface',
    ENABLE_KNOWLEDGE_GRAPH: 'enableKnowledgeGraph',
    GENERATE_QUESTIONS: 'generateQuestions',
});

export const ExtractionFeatures = Object.freeze({
    SELECT_TEMPLATE: 'selectTemplate',
    EXTRACT_DATA: 'extractData',
    ADD_TEMPLATE: 'addTemplate',
    DOWNLOAD_DATA: 'downloadData',
    VIEW_REPORT: 'viewReport',
});

export const TemplateFeatures = Object.freeze({
    ADD_TEMPLATE: 'addTemplate',
    IMPORT_TEMPLATE: 'importTemplate',
    EXPORT_TEMPLATE: 'exportTemplate',
    DELETE_TEMPLATE: 'deleteTemplate',
});

export const LayoutFeatures = Object.freeze({
    ADD_LAYOUT: 'addLayout',
    COPY_LAYOUT: 'copyLayout',
    EXPORT_LAYOUT: 'exportLayout',
    DELETE_LAYOUT: 'deleteLayout',
});

export const SupportFeatures = Object.freeze({
    CONTACT_US: 'contactUs',
});

export const BillingFeatures = Object.freeze({
    USAGE_ANALYTICS_GRAPH: 'usageAnalyticsGraph',
    CURRENT_PLAN_AND_OTHER_INFO: 'currentPlanAndOtherInfo',
    MANAGE_SUBSCRIPTION: 'manageSubscription',
});

export const SettingsFeatures = Object.freeze({
    ADMIN_SETTINGS: 'adminSettings',
    ACCOUNT_SETTINGS: 'accountSettings',
    SUPPORT_SETTINGS: 'supportSettings',
    GENERAL_SETTINGS: 'generalSettings',
    ORGANIZATION_SETTINGS: 'organizationSettings',
    ORGANIZATION_MANAGEMENT: 'organizationManagement',
    CHAT_SETTINGS: 'chatSettings',
    PROMPT_SETTINGS: 'promptSettings',
    SYSTEM_SETTINGS: 'systemSettings',
});

export const OtherFeatures = Object.freeze({
    LOGO: 'logo',
    POWERED_BY: 'poweredBy',
    LOGOUT_BUTTON: 'logoutButton',
    USER_INFORMATION: 'userInformation',
    MODEL_SELECTION: 'modelSelection',
    LANDING_PAGE: 'landingPage',
});
